import store from "../../root/store/store";
import { constants } from "../constant/constants";
import { HttpHelper } from "../helper/http-helper-service";
import { invoicePaginationObject } from "../model/invoice/invoice-response-model";

export default class billingService {
    constructor() {
    }

    // ENG-7498: Billing scopes a contact's invoice reads and tick list to their client. The production gateway
    // does not add ClientId for contacts yet, so send it here; once the gateway injects it, it overrides this.
    private static clientIdQuery = () => {
        const clientId: number | null = store.getters["ContactModule/getClientId"];
        return clientId ? "?ClientId=" + clientId : "";
    }

    static getInvoiceById = (invoiceid: string) => {
        return HttpHelper.getData(constants.apiUrl.billingUrls.getInvoiceById + "/" + invoiceid + billingService.clientIdQuery());
    }

    static getInvoice = (pagination: invoicePaginationObject) => {
        return HttpHelper.postData(constants.apiUrl.billingUrls.getInvoice, pagination);
    }

    static getInvoicesByTick = (obj: any) => {
        return HttpHelper.postData(constants.apiUrl.billingUrls.getInvoicesByTick + billingService.clientIdQuery(), obj);
    }

    static downloadInvoice = (params: any, invoiceNumber: string) => {
        return HttpHelper.postDataToGetFile(constants.apiUrl.billingUrls.downloadInvoice, params, invoiceNumber);
    }

    static getInvoiceListById = (id: string) => {
        return HttpHelper.getData(constants.apiUrl.billingUrls.getInvoiceListById + "/" + id + billingService.clientIdQuery(), {});
    }

    static getPublicXeroLink = (externalInvoiceId: string) => {
        return HttpHelper.getData(constants.apiUrl.billingUrls.getPublicXeroLink + "/" + externalInvoiceId, {});
    }

    static getInvoiceCurrency = (apiCallAbortSignal: AbortSignal | undefined = undefined) => {
        return HttpHelper.getData(constants.apiUrl.billingUrls.getInvoiceCurrency, null);
    }

    static getContracts = (obj: any) => {
        return HttpHelper.postData(constants.apiUrl.billingUrls.getContracts, obj);
    }
}
